export { default as CVE } from './CVE'
export { default as MyCompany } from './MyCompany'
export { default as Offerings } from './Offerings'
export { default as OurApproach } from './OurApproach'
export { default as Hero } from './Hero'
export { default as WhatWeDo } from './WhatWeDo'
export { default as CaseStudies } from './CaseStudies'
export { default as SubHero } from './SubHero/index'
